// General
import React, { useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { DevicesContext } from "../../data/devices/DevicesContext";
import { useValidations } from "../../data/ValidationContext";

const DevicesAddModal = ({ isOpen, onClose }) => {
  const { devicesList, addDevice } = useContext(DevicesContext);
    const { vs_device } = useValidations(); 

  const initialValues = {
    brand: "",
    model: "",
    description: "",
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Formik
        initialValues={initialValues}
        validationSchema={vs_device}
        onSubmit={(values) => {
          // Benzersiz cihaz kontrolü (brand+model)
          const isDuplicate = devicesList.some(
            (d) =>
              d.brand.toLowerCase() === values.brand.toLowerCase() &&
              d.model.toLowerCase() === values.model.toLowerCase()
          );
          if (isDuplicate) {
            alert("Bu cihaz zaten mevcut!");
            return;
          }

          addDevice(values);
          onClose();
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Cihaz Ekle</Modal.Title>
            </Modal.Header>

            <Modal.Body className="d-flex flex-col gap-3">
              <TextField
                label="Marka"
                name="brand"
                value={values.brand}
                onChange={handleChange}
                fullWidth
                size="small"
                error={touched.brand && !!errors.brand}
                helperText={touched.brand && errors.brand}
              />

              <TextField
                label="Model"
                name="model"
                value={values.model}
                onChange={handleChange}
                fullWidth
                size="small"
                error={touched.model && !!errors.model}
                helperText={touched.model && errors.model}
              />

              <TextField
                label="Açıklama"
                name="description"
                value={values.description}
                onChange={handleChange}
                fullWidth
                size="small"
                multiline
                minRows={2}
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
              />
            </Modal.Body>

            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DevicesAddModal;
